import { Component, OnInit } from '@angular/core';
import {DefaultApi} from '../service/default.api';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
    selector: 'app-recovery',
    templateUrl: './recovery.component.html',
    standalone: false
})
export class RecoveryComponent implements OnInit {
  credentials = {
    email: '',
    textMessage: '',
    textMessage2: '',
    sessionId: ''
  };

  public loading = false;
  constructor(private api: DefaultApi, private route: ActivatedRoute,
              private _snackBar: MatSnackBar, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.credentials.sessionId  = params.sessionId;
      console.log('!!!!!!!!!!!!! session id = ' + this.credentials.sessionId);
    });
  }

  onSubmit() {
    this.credentials.email = this.credentials.email.trim();
    this.api.recoverPassword(this.credentials)
      .subscribe(
        () => {
          this.loading = false;
          this.api.initSession().subscribe(() => {
            window.location.href = `/portals/`;
          });
        },
        (response) => {
          this._snackBar.open(response.error, 'Dismiss', {
            duration: 4000,
          });
          this.loading = false;
        }
      );
  }
}
